import React from "react";
import "./ProgressChart.css";

const Tooltip = ({ count, atRiskCount = 0 }) => {
  const hasAtRisk = atRiskCount > 0;
  return (
    <div className="tooltip">
      <div className={`count ${hasAtRisk ? "hasBorder" : ""} `}> {count} </div>
      {hasAtRisk && (
        <div className="tooltiptext">
          <div className="arrow"></div>
          <text>At Risk: {atRiskCount}</text>
        </div>
      )}
    </div>
  );
};

const ProgressBar = ({ progress, color, style }) => {
  return (
    <div className="progress-bar" style={style}>
      <div
        className="progress"
        style={{
          width: progress ? `${progress}%` : "0px",
          backgroundColor: color,
        }}
      ></div>
    </div>
  );
};

const ProgressItem = ({ id, label, value, count, atRiskCount, itemIndex, colors, onClick }) => {
  return (
    <div
      className={`flex row padding align-center cursor ${itemIndex !== 0 ? "top-border" : ""
        }`}
      onClick={() => {
        onClick({ id, label });
      }}
    >
      <div className="label" style={{ width: "40%", maxWidth: "40%" }}>
        {label}
      </div>
      <ProgressBar
        progress={value}
        style={{ width: "100%" }}
        color={colors[itemIndex]}
      />
      <Tooltip count={count} atRiskCount={atRiskCount} />
    </div>
  );
};

const ProgressChart = ({ progress, colors, onClick }) => (
  <div className="flex column full-border container">
    {progress.map((item, index) => (
      <ProgressItem
        {...item}
        key={index}
        itemIndex={index}
        colors={colors}
        onClick={(row) => onClick(row)}
      />
    ))}
  </div>
);

export default ProgressChart;
